export const statusOptions = [
  { label: 'Design completed', value: 'COMPLETED' },
  { label: 'Design pending', value: 'PENDING' },
  { label: 'Design rejected', value: 'REJECTED' },
];

export const dateOptions = [
  { label: 'Last 7 days', value: 'last_7_days' },
  { label: 'Last 30 days', value: 'last_30_days' },
  { label: 'Last 3 months', value: 'last_3_months' },
  { label: 'Last 6 months', value: 'last_6_months' },
  { label: 'Last year', value: 'last_year' },
];

export const radioOptions = [
  { label: 'Start & End Date', value: 'date' },
  { label: 'Quick Range', value: 'range' },
  { label: 'Status', value: 'status' },
];
